import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "../../../resources/styles.scss";
import { withRouter } from 'react-router-dom';
import { withTranslation, Trans } from 'react-i18next';
import tankService from "../../../services/tanksService";

const emptyTankOperation = {
    tankId: "0",
    fuelType: "",
    provider: "",
    description: "",
    balance: 0,
    deliveryDate: new Date()
};

const EditTankOperation = ({ match, history, t }) => {
    const [item, setItem] = useState({ ...emptyTankOperation, deliveryDate: new Date() });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
            const tankId = parseInt(match.params.id);
            setItem({...item, tankId});
        }, []);

    const onDateChanged = (date) => {
        const newState = Object.assign({}, item);
        newState.deliveryDate = date;
        setItem(newState);
    }

    const updateStateProp = (propName, propValue) => {
        const newState = Object.assign({}, item);
        newState[propName] = propValue;
        setItem(newState);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        await tankService.addTankOperationAsync(item);
        setLoading(false);
        history.push('/tanks/tankdetails/' + item.tankId);
    }

    const cancel = (e) => {
        e.preventDefault();
        history.goBack();
    }

    return (
        <div className="form_container">
            <form className="edit-form" onSubmit={handleSubmit}>
                <div className="form-body">
                    <p>
                        <label><Trans>TankOperation.fuelType</Trans></label>
                        <input type="text" value={item.fuelType} onChange={(e) => { updateStateProp("fuelType", e.target.value) }} />
                    </p>
                    <p>
                        <label><Trans>TankOperation.provider</Trans></label>
                        <input type="text" value={item.provider} onChange={(e) => { updateStateProp("provider", e.target.value) }} />
                    </p>
                    <p>
                        <label><Trans>TankOperation.description</Trans></label>
                        <input type="text" value={item.description} onChange={(e) => { updateStateProp("description", e.target.value) }} />
                    </p>
                    <p>
                        <label><Trans>TankOperation.balance</Trans></label>
                        <input type="number" value={item.balance} onChange={(e) => { updateStateProp("balance", (e.target.value)) }} step="any" />
                    </p>
                    <div>
                        <label><Trans>TankOperation.deliveryDate</Trans></label>
                        <DatePicker selected={item.deliveryDate}
                            onChange={date => onDateChanged(date)}
                            timeFormat="HH:mm"
                            showTimeInput
                            timeIntervals={1}
                            dateFormat="dd/MM/yyyy HH:mm"
                            placeholderText={t("date")} />
                    </div>
                    <div className="form-buttons-container">
                        <button type="submit"><Trans>Table.saveButton</Trans></button>
                        <button onClick={cancel}><Trans>Table.cancelButton</Trans></button>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default withRouter(withTranslation("translations")(EditTankOperation));